'use client';

import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useRef, useState } from 'react';
import './index.scss';
import getLocal from '@/app/utils/i18n';

export default function Content({ id, data = {} }: ContentServerProps) {
    const { list = [], backgroundColor = '#00000', cardBackgroundColor = '#18191b' } = data;
    const { locale = 'us' } = getLocal();

    const containerRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const [finalList, setFinalList] = useState<any[]>([]);

    useEffect(() => {
        if (!containerRef.current || list.length === 0) return;
        const GAP = 12;
        const update = () => {
            const containerWidth = containerRef.current!.offsetWidth;
            // 计算卡片宽度
            let cardWidth = 350;
            if (containerWidth <= 1024) {
                cardWidth = 120;
            } else if (containerWidth <= 1440) {
                cardWidth = 208;
            }

            const itemFullWidth = cardWidth + GAP;
            const singleWidth = list.length * itemFullWidth;

            // ⭐ 必须至少 2 份 list（循环块）
            let duplicatedCount = 2;
            // ⭐ 若单份不足 1 屏，则保证至少覆盖 2 屏
            while (singleWidth * duplicatedCount < containerWidth * 2) {
                duplicatedCount++;
            }
            const duplicated = Array.from({ length: duplicatedCount }, () => list).flat();
            setFinalList(duplicated);
            // 动画核心：只移动 1 份宽度
            contentRef.current?.style.setProperty('--move-distance', `${singleWidth}px`);
            contentRef.current?.style.setProperty('--move-duration', `${list.length * 3}s`);
        };

        update();
        const ro = new ResizeObserver(update);
        ro.observe(containerRef.current);
        return () => ro.disconnect();
    }, [list]);

    return (
        <GloLayout className={`editor-index-list-b1`} id={id} data={data} floorName="index-list-b1">
            <div className="index-list-b1-list" ref={containerRef} style={{ backgroundColor: locale === 'jp' ? backgroundColor : undefined }}>
                <div className="index-list-b1-list-content" ref={contentRef}>
                    {finalList.map((itemA: any, index: number) => {
                        return (
                            <div key={index} className="index-list-b1-item" style={{ backgroundColor: locale === 'jp' ? cardBackgroundColor : undefined }}>
                                <EcoImg pc={itemA.pc} h5={itemA.h5} className="index-list-b1-item-img" />
                                <div className="index-list-b1-item-msg">
                                    <div className="index-list-b1-item-title" style={{ color: itemA.titleColor }}>
                                        {itemA.title}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </GloLayout>
    );
}
